<div #layout>
  <ng-content></ng-content>
</div>
